module.exports = __webpack_public_path__ + "img/Group.fa51eddf.png";